import "./summary-questions.component.scss";
import { useEffect, useState } from "react";
import { QuestionsSummaryModel } from "../../../model/questions-summary.model";
import { Divider } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import AI_PURPLE from "../../../assets/images/ai-icon-purple.png";

interface SummaryCreateQuestionProps {
    isSubmitStep4: boolean
    interview: QuestionsSummaryModel;
    onSubmit(value): void;
    onBack(step): void;
}

const SummaryCreateQuestionComponent: React.FC<SummaryCreateQuestionProps> = ({ onSubmit, onBack, interview, isSubmitStep4 }) => {
    const [summaryModel, setSummaryModel] = useState<QuestionsSummaryModel>(interview);
    const [movingIndex, setMovingIndex] = useState<number | null>(null); // To trigger animation
    const [isJobExpand, setIsJobExpand] = useState(false);
    useEffect(() => {
        console.log(interview);
        setSummaryModel(interview);
    }, [interview])
    useEffect(() => {

        if (isSubmitStep4) {
            onSubmit(summaryModel);
        }
    }, [isSubmitStep4])



    // ✅ Move Question Up
    const reorderUp = (index: number) => {
        if (index === 0) return; // Already at top, no need to move

        animateMove(index);
        setTimeout(() => {
            const updatedQuestions = [...summaryModel.questions];
            [updatedQuestions[index], updatedQuestions[index - 1]] = [updatedQuestions[index - 1], updatedQuestions[index]];
            setSummaryModel({ ...summaryModel, questions: updatedQuestions });
        }, 300)
    };

    // ✅ Move Question Down
    const reorderDown = (index: number) => {
        if (index === summaryModel.questions.length - 1) return; // Already at bottom, no need to move

        animateMove(index);
        setTimeout(() => {
            const updatedQuestions = [...summaryModel.questions];
            [updatedQuestions[index], updatedQuestions[index + 1]] = [updatedQuestions[index + 1], updatedQuestions[index]];
            setSummaryModel({ ...summaryModel, questions: updatedQuestions });
        }, 300)
    };

    // ✅ Set movingIndex to trigger animation
    const animateMove = (index: number) => {
        setMovingIndex(index);
    };

    return (
        <>
            <div className="summary-questions-control">
                {
                    summaryModel &&

                    <div className="summary-questions-item-control">
                        <div className="border-std summary-questions-item-flex-control">
                            <div className="summary-questions-title-control">
                                <img src={AI_PURPLE} className="summary-questions-title-icon"></img>
                                <span className="summary-questions-title">ชื่อชุดคำถาม : คำถามสัมภาษณ์ในตำแหน่งงาน {interview.job_position.job_title}</span>
                            </div>
                            <span className="summary-questions-title-desc">ภาษา: อังกฤษ และ ไทย | Tone: ทางการ | เวลาที่ใช้ในการสัมภาษณ์: 30 นาที | ผู้สมัครต้องเปิด กล้อง และไมค์ ขณะสัมภาษณ์</span>
                        </div>

                        <div className="border-std summary-questions-item-flex-control">
                            <div className="summary-questions-title-control">
                                <div className="summary-questions-title-circle"></div>
                                <span className="summary-questions-title">ข้อมูลตำแหน่งงาน</span>

                                <FontAwesomeIcon icon={faChevronDown} className="summary-questions-arrow"
                                    onClick={
                                        () => {
                                            setIsJobExpand(!isJobExpand);
                                        }
                                    }
                                ></FontAwesomeIcon>
                            </div>
                            {
                                isJobExpand ?
                                    <div className="summary-questions-list-control">
                                        {

                                            summaryModel.job_position &&
                                            <>
                                                <div className="summary-questions-text-flex-control">
                                                    <span className="summary-questions-text-flex-title">ตำแหน่งงาน:</span>
                                                    <span className="summary-questions-text-flex-desc">{summaryModel.job_position.job_title}</span>
                                                </div>
                                                <div className="summary-questions-text-flex-control">
                                                    <span className="summary-questions-text-flex-title">ประเภทการเข้างาน:</span>
                                                    <span className="summary-questions-text-flex-desc">{summaryModel.job_position.job_work_type}</span>
                                                </div>
                                                <div className="summary-questions-text-flex-control">
                                                    <span className="summary-questions-text-flex-title">ประเภทการจ้างงาน:</span>
                                                    <span className="summary-questions-text-flex-desc">{summaryModel.job_position.job_employment}</span>
                                                </div>
                                                <div className="summary-questions-text-flex-control">
                                                    <span className="summary-questions-text-flex-title">เลเวลที่ต้องการ:</span>
                                                    <span className="summary-questions-text-flex-desc">{summaryModel.job_position.job_level}</span>
                                                </div>
                                                <div className="summary-questions-text-flex-control">
                                                    <span className="summary-questions-text-flex-title">ประสบการณ์ของตำแหน่งงานนี้:</span>
                                                    <span className="summary-questions-text-flex-desc">{summaryModel.job_position.job_exp}</span>
                                                </div>
                                                <div className="summary-questions-text-flex-control">
                                                    <span className="summary-questions-text-flex-title">เงินเดือนที่ต้องการ:</span>
                                                    <span className="summary-questions-text-flex-desc">{summaryModel.job_position.job_salary}</span>
                                                </div>
                                                <div className="summary-questions-text-flex-control">
                                                    <span className="summary-questions-text-flex-title">ประเภทธุรกิจ:</span>
                                                    <span className="summary-questions-text-flex-desc">{summaryModel.job_position.job_industry}</span>
                                                </div>
                                                <div className="summary-questions-text-flex-control">
                                                    <span className="summary-questions-text-flex-title">ประเภทงาน:</span>
                                                    <span className="summary-questions-text-flex-desc">{summaryModel.job_position.job_department}</span>
                                                </div>
                                                {
                                                    summaryModel.job_position.job_advance.job_description &&
                                                    <div className="summary-questions-text-flex-column-control">
                                                        <span className="summary-questions-text-flex-title">รายละเอียดตำแหน่งงาน:</span>
                                                        <span className="summary-questions-text-flex-desc">{summaryModel.job_position.job_advance.job_description}</span>
                                                    </div>
                                                }

                                                {
                                                    summaryModel.job_position.job_advance.job_qualification &&
                                                    <div className="summary-questions-text-flex-column-control">
                                                        <span className="summary-questions-text-flex-title">Qualification:</span>
                                                        <span className="summary-questions-text-flex-desc">{summaryModel.job_position.job_advance.job_qualification}</span>
                                                    </div>
                                                }

                                                {
                                                    summaryModel.job_position.job_advance.soft_skills &&
                                                    <div className="summary-questions-text-flex-column-control">
                                                        <span className="summary-questions-text-flex-title">Soft Skill (ทักษะการใช้ชีวิต):</span>
                                                        {
                                                            summaryModel.job_position.job_advance.soft_skills && summaryModel.job_position.job_advance.soft_skills.length > 0 &&
                                                            <div className="summary-questions-list-tag-control">
                                                                {summaryModel.job_position.job_advance.soft_skills.map((itemNeed, indexNeed) => {
                                                                    return (
                                                                        <div className="summary-questions-list-tag" key={indexNeed}>
                                                                            #{itemNeed}
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        }
                                                    </div>
                                                }

                                                {
                                                    summaryModel.job_position.job_advance.hard_skills &&
                                                    <div className="summary-questions-text-flex-column-control">
                                                        <span className="summary-questions-text-flex-title">Hard Skill (ทักษะด้านการทำงาน):</span>
                                                        {
                                                            summaryModel.job_position.job_advance.hard_skills && summaryModel.job_position.job_advance.hard_skills.length > 0 &&
                                                            <div className="summary-questions-list-tag-control">
                                                                {summaryModel.job_position.job_advance.hard_skills.map((itemNeed, indexNeed) => {
                                                                    return (
                                                                        <div className="summary-questions-list-tag" key={indexNeed}>
                                                                            #{itemNeed}
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        }
                                                    </div>
                                                }

                                                {
                                                    summaryModel.job_position.job_advance.tool_and_technology &&
                                                    <div className="summary-questions-text-flex-column-control">
                                                        <span className="summary-questions-text-flex-title">Tool Technology:</span>
                                                        {
                                                            summaryModel.job_position.job_advance.tool_and_technology && summaryModel.job_position.job_advance.tool_and_technology.length > 0 &&
                                                            <div className="summary-questions-list-tag-control">
                                                                {summaryModel.job_position.job_advance.tool_and_technology.map((itemNeed, indexNeed) => {
                                                                    return (
                                                                        <div className="summary-questions-list-tag" key={indexNeed}>
                                                                            #{itemNeed}
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        }
                                                    </div>
                                                }


                                                {
                                                    summaryModel.job_position.job_advance.leadership_expectation &&
                                                    <div className="summary-questions-text-flex-column-control">
                                                        <span className="summary-questions-text-flex-title">Leadership Skills:</span>
                                                        {
                                                            summaryModel.job_position.job_advance.leadership_expectation && summaryModel.job_position.job_advance.leadership_expectation.length > 0 &&
                                                            <div className="summary-questions-list-tag-control">
                                                                {summaryModel.job_position.job_advance.leadership_expectation.map((itemNeed, indexNeed) => {
                                                                    return (
                                                                        <div className="summary-questions-list-tag" key={indexNeed}>
                                                                            #{itemNeed}
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        }
                                                    </div>
                                                }

                                                {
                                                    summaryModel.job_position.job_advance.company_culture &&
                                                    <div className="summary-questions-text-flex-column-control">
                                                        <span className="summary-questions-text-flex-title">Culture:</span>
                                                        {
                                                            summaryModel.job_position.job_advance.company_culture && summaryModel.job_position.job_advance.company_culture.length > 0 &&
                                                            <div className="summary-questions-list-tag-control">
                                                                {summaryModel.job_position.job_advance.company_culture.map((itemNeed, indexNeed) => {
                                                                    return (
                                                                        <div className="summary-questions-list-tag" key={indexNeed}>
                                                                            #{itemNeed}
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        }
                                                    </div>
                                                }


                                            </>
                                        }
                                    </div> : <></>
                            }
                        </div>



                        {/* ✅ AI Generated Questions */}
                        <div className="border-std summary-questions-item-grid-control">

                            <div className="summary-questions-topic-control">
                                <div className="summary-questions-title-control">
                                    <img src={AI_PURPLE} className="summary-questions-title-icon"></img>
                                    <span className="summary-questions-title">คำถามที่เลือกทั้งหมด {interview.questions.length} ข้อ</span>
                                </div>
                                <span className="summary-question-item-topic-desc">สามารถจัดลำดับของคำถามได้ หรือย้อนกลับ
                                    เพื่อกลับไปแก้ไขคำถาม</span>
                            </div>
                            <div className="summary-questions-list-control">
                                {summaryModel.questions && summaryModel.questions.length > 0 && summaryModel.questions.map((item, index) => (
                                    <div
                                        className={`summary-questions-list-item-control-flex ${movingIndex === index ? "moving" : ""}`}
                                        key={item.question_id}
                                    >
                                        <span className="summary-question-list-item-index">{index+1}</span>
                                        <div className="summary-questions-list-item-flex-column">
                                            <div className="summary-questions-list-item-control">
                                                <div className="summary-questions-list-item-question">
                                                    <span className="th">{item.question.th}</span>
                                                    <span className="en">{item.question.en}</span>
                                                    {
                                                        item.need_skills && item.need_skills.length > 0 &&
                                                        <div className="summary-questions-list-tag-control">
                                                            {item.need_skills.map((itemNeed, indexNeed) => {
                                                                return (
                                                                    <div className="summary-questions-list-tag" key={indexNeed}>
                                                                        #{itemNeed}
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    }
                                                </div>
                                                <div className="summary-questions-reorder-control">
                                                    {
                                                        index !== summaryModel.questions.length - 1 &&
                                                        <div
                                                            onClick={() => reorderDown(index)}
                                                            className="summary-questions-reordersummary-questions-reorder-button-control">
                                                            <FontAwesomeIcon className="icon" icon={faChevronDown}></FontAwesomeIcon>
                                                        </div>
                                                    }

                                                    {
                                                        index !== 0 &&
                                                        <div
                                                            onClick={() => reorderUp(index)}
                                                            className="summary-questions-reordersummary-questions-reorder-button-control">
                                                            <FontAwesomeIcon className="icon" icon={faChevronUp}></FontAwesomeIcon>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                          
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

export default SummaryCreateQuestionComponent;